import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { getCountry, DEFAULT_COUNTRY } from '../lib/countryConfig';

const CountryContext = createContext(null);

const STORAGE_KEY = 'gd-country-mode';

export function CountryProvider({ children }) {
  const [countryCode, setCountryCode] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || DEFAULT_COUNTRY;
    } catch {
      return DEFAULT_COUNTRY;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, countryCode);
    } catch {}
    // Apply CSS variables for the current country brand palette
    const c = getCountry(countryCode);
    const root = document.documentElement;
    root.style.setProperty('--gd-primary', c.palette.primary);
    root.style.setProperty('--gd-primary-hover', c.palette.primaryHover);
    root.style.setProperty('--gd-accent', c.palette.accent);
    root.style.setProperty('--gd-light', c.palette.light);
    root.style.setProperty('--gd-surface', c.palette.surface);
    root.style.setProperty('--gd-success', c.palette.success);
    root.style.setProperty('--gd-warning', c.palette.warning);
    root.style.setProperty('--gd-danger', c.palette.danger);
  }, [countryCode]);

  const value = useMemo(() => {
    const country = getCountry(countryCode);
    return {
      countryCode,
      country,
      setCountry: setCountryCode,
      // helpers
      t: country.labels,
      isQuebec: countryCode === 'quebec',
      isSenegal: countryCode === 'senegal',
    };
  }, [countryCode]);

  return <CountryContext.Provider value={value}>{children}</CountryContext.Provider>;
}

export function useCountry() {
  const ctx = useContext(CountryContext);
  if (!ctx) throw new Error('useCountry must be used inside CountryProvider');
  return ctx;
}
